import { render, staticRenderFns } from "./pruebasCourse.vue?vue&type=template&id=b936ac20&scoped=true"
import script from "./pruebasCourse.vue?vue&type=script&lang=js"
export * from "./pruebasCourse.vue?vue&type=script&lang=js"
import style0 from "./pruebasCourse.vue?vue&type=style&index=0&id=b936ac20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b936ac20",
  null
  
)

export default component.exports